/* eslint-disable */
// @ts-nocheck
import { api, type FetchOptions } from "@/api"
import { queryOptions, useQuery, useQueryClient, useMutation } from "@tanstack/react-query"

type ReferralQueryParams = {
    page?: number
    pageSize?: number
    facility?: number
    search?: string
}

const referralKeys = {
    all: ["referrals"] as const,
    list: () => [...referralKeys.all, "list"] as const,
    lists: <TQuery extends ReferralQueryParams>(query?: TQuery) => [...referralKeys.list(), { query }] as const,
}

export const referralsQueryOptions = (
    fetchOpts?: FetchOptions<"get", "/referrals/">
) => {
    const query = fetchOpts?.params?.query as ReferralQueryParams

    return queryOptions({
        queryKey: referralKeys.lists(query),
        queryFn: () => api.GET("/referrals/", { params: { query } }).then(({ data }) => data),
        enabled: !!query?.facility,
    })
}

export const useReferralsQuery = (
    fetchOpts?: FetchOptions<"get", "/referrals/">
) => {
    // Set default pageSize to 100 if not provided
    const enhancedFetchOpts = {
        ...fetchOpts,
        params: {
            ...fetchOpts?.params,
            query: {
                pageSize: 100,
                ...fetchOpts?.params?.query,
            }
        }
    }

    return useQuery(referralsQueryOptions(enhancedFetchOpts))
}

// Add mutation to update referral statuses
export const useUpdateReferralStatusesMutation = () => {
    const queryClient = useQueryClient()

    return useMutation({
        mutationFn: (data: { ids: number[], status: string }) =>
            api.PUT("/referrals/status/", { body: data }).then(res => res.data),
        onSuccess: () => {
            // Invalidate referrals list queries to refetch data
            queryClient.invalidateQueries({ queryKey: referralKeys.list() })
        }
    })
}

// Add mutation to update referral notes
export const useUpdateReferralNotesMutation = () => {
    const queryClient = useQueryClient()

    return useMutation({
        mutationFn: ({ id, notes }: { id: number, notes: string }) =>
            api.PUT(`/referrals/${id}/notes/`, { body: { notes } }).then(res => res.data),
        onSuccess: () => {
            // Invalidate referrals list queries to refetch data
            queryClient.invalidateQueries({ queryKey: referralKeys.list() })
        }
    })
}
